import React from 'react';
import type { YouTubeVideoBlockProps } from '@noths/polaris-client-ribbons-design-system';
import { YouTubeVideoBlock } from '@noths/polaris-client-ribbons-design-system';

import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import {
  trackYouTubeVideoClick,
  trackYouTubeVideoImpression,
} from 'src/tracking/components/videoBlock';
import * as styles from './YouTubeVideoBlockSection.style';

export interface YouTubeVideoBlockBlockSection extends YouTubeVideoBlockProps {
  trackingPosition?: number;
  trackingTitle: string;
}

export const YouTubeVideoBlockSection = ({
  title,
  trackingPosition,
  trackingTitle,
  ...restOfProps
}: YouTubeVideoBlockBlockSection) => {
  const trackingContext = {
    trackingPosition,
    trackingTitle,
    videoTitle: title || '',
  };

  return (
    <SectionContainer columnsL={8} maxWidth="full" wrapperStyles={styles.wrapper}>
      <YouTubeVideoBlock
        onVideoClick={() => trackYouTubeVideoClick(trackingContext)}
        onVisible={() => trackYouTubeVideoImpression(trackingContext)}
        title={title}
        {...restOfProps}
      />
    </SectionContainer>
  );
};
